import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  PDFViewer,
  Image,
} from "@react-pdf/renderer";
import image from "../../../assets/img/marifer.png";

const styles = StyleSheet.create({
  image2: {
    position: "absolute",
    objectPosition: "0",
    zIndex: -999,
    width: "320px",
    height: "320px",
    opacity: 0.2,
  },
  image: {
    position: "relative",
    objectFit: "cover",
    zIndex: -999,
    width: "120px",
    height: "120px",
    paddingLeft: 0,
    opacity: 0.9,
  },
  header: {
    color: "#ff0080",
    textTransform: "uppercase",
    marginTop: 15,
    paddingLeft: 50,
    fontSize: "18pt",
    fontWeight: "extrabold",
  },
  page: {
    fontSize: "14pt",
    padding: 10,
  },
  mainSection: {
    flexDirection: "row",
    textAlign: "center",
    height: "7.975cm",
  },
  section1: {
    padding: 8,
    textAlign: "center",
    width: "7cm",
    height: "100%",
    backgroundColor: "white",
    border: 1,
    borderColor: "#0A83F5",
    lineHeight: 1.5,
    fontSize: "10pt",
  },
  section2: {
    padding: 8,
    lineHeight: 4,
    border: 1,
    borderColor: "#0A83F5",
    width: "14.6cm",
    height: "100%",
    backgroundColor: "white",
  },
  viewer: {
    width: "100%",
    height: window.innerHeight,
  },
});

const ReportGarmentPdf = ({ productosAgrupados }) => {
  const totalGeneral = productosAgrupados.reduce(
    (acumulador, item) => acumulador + item.total,
    0
  );
  return (
    <PDFViewer style={styles.viewer}>
      <Document>
        <Page>
          <View style={styles.mainSection}>
            <View>
              <Image style={styles.image} src={image} />
            </View>
            <View>
              <Text style={styles.header}>
                {"Reporte General de Modelos en Stock"}
              </Text>
            </View>
          </View>

          {/* --- Segunda sección (resumen) --- */}
          <View
            style={{
              fontSize: 10,
              flexDirection: "row",
              textAlign: "center",
              wordWrap: "word-break",
              paddingLeft: 295,
              marginTop: -150,
              paddingBottom: 5,
            }}
          >
            <View>
              <View>
                <Text
                  style={{
                    border: 1,
                    padding: 1,
                    width: 250,
                    textAlign: "center",
                  }}
                >
                  {"Total de Productos en almacen"}
                </Text>
              </View>
              <Text
                style={{
                  border: 1,
                  width: 250,
                  padding: 1,
                  height: 25,
                  color: "gray",
                  textAlign: "center",
                }}
              >
                {totalGeneral}
              </Text>
            </View>
          </View>

          <View style={{ border: 1, marginTop: 1 }}>
            {/* <View style={{ alignItems: "center" }}>
              <Image src={image} style={styles.image2} />
            </View> */}

            {/* Encabezado tabla */}
            <View
              style={{
                flexDirection: "row",
                textAlign: "center",
                fontWeight: "extrabold",
                fontSize: "11pt",
                backgroundColor: "#e6e6e6",
                height: 20,
              }}
            >
              <View style={{ width: "100%", border: 1 }}>
                <Text style={{ color: "#000" }}>{"Modelos en Almancen"}</Text>
              </View>
            </View>

            {/* Sub-encabezado */}
            <View
              style={{
                flexDirection: "row",
                textAlign: "center",
                fontSize: "10pt",
                color: "#000111",
                height: 20,
                backgroundColor: "#f9c6cf",
              }}
            >
              <View style={{ width: "5%", border: 1, padding: "3px" }}>
                <Text>{"No."}</Text>
              </View>
              <View style={{ width: "25%", border: 1, padding: "3px" }}>
                <Text>{"Imagen"}</Text>
              </View>
              <View style={{ width: "25%", border: 1, padding: "3px" }}>
                <Text>{"Nombre"}</Text>
              </View>
              <View style={{ width: "10%", border: 1, padding: "3px" }}>
                <Text>{"Sku"}</Text>
              </View>
              <View style={{ width: "25%", border: 1, padding: "3px" }}>
                <Text>{"Por Tallas"}</Text>
              </View>
              <View style={{ width: "10%", border: 1, padding: "3px" }}>
                <Text>{"Cantidad"}</Text>
              </View>
            </View>

            {/* Filas agrupadas */}
            {productosAgrupados.length === 0 ? (
              <View
                style={{
                  flexDirection: "row",
                  textAlign: "center",
                  fontSize: "10pt",
                  color: "#000111",
                }}
              >
                <View style={{ width: "100%", border: 1, padding: "3px" }}>
                  <Text>{"No hay datos para mostrar."}</Text>
                </View>
              </View>
            ) : (
              productosAgrupados.map((p, idx) => (
                <View
                  key={idx}
                  style={{
                    flexDirection: "row",
                    textAlign: "center",
                    fontSize: "8pt",
                    color: "#000111",
                  }}
                >
                  <View style={{ width: "5%", border: 1, padding: "3px" }}>
                    <Text>{idx + 1}</Text>
                  </View>
                  <View
                    style={{
                      width: "25%",
                      border: 1,
                      padding: 3,
                      alignItems: "center", // ✅ Centra horizontalmente
                      justifyContent: "center", // ✅ Centra verticalmente
                      textAlign: "center",
                    }}
                  >
                    {p.imagen ? (
                      <Image
                        src={p.imagen}
                        style={{
                          width: 60,
                          height: 60,
                          objectFit: "contain",
                          borderRadius: 4,
                          marginVertical: 2,
                          alignSelf: "center", // ✅ Asegura centrado dentro del View
                        }}
                      />
                    ) : (
                      <Text style={{ color: "gray", fontSize: 8 }}>
                        Sin imagen
                      </Text>
                    )}
                  </View>
                  <View style={{ width: "25%", border: 1, padding: "3px" }}>
                    <Text>{p.nombre}</Text>
                  </View>
                  <View style={{ width: "10%", border: 1, padding: "3px" }}>
                    <Text>{p.sku}</Text>
                  </View>
                  <View style={{ width: "25%", border: 1, padding: "3px" }}>
                    {p.tallas.map((item) => (
                      <Text>{item.nombre}</Text>
                    ))}
                  </View>
                  <View style={{ width: "10%", border: 1, padding: "3px" }}>
                    {p.tallas.map((item) => (
                      <Text>{item.cantidad}</Text>
                    ))}
                  </View>
                </View>
              ))
            )}
          </View>
        </Page>
      </Document>
    </PDFViewer>
  );
};

export default ReportGarmentPdf;
